import { formatSharePercent } from './poolShareOfGross';

const amountOf = (value) => parseFloat(value || 0) || 0;

const GUARANTEE_ALWAYS_ADDED = ['remainder', 'equal_share_of_remainder'];

const shareFor = (member) => {
  const percent = amountOf(member.percentage);
  switch (member.payout_strategy) {
    case 'remainder':
      return 'the rest of the pool';
    case 'equal_share_of_remainder':
      return 'an equal share of what is left in the pool';
    case 'percentage_of_remainder':
      return percent > 0 ? `${formatSharePercent(percent)} of what is left in the pool` : null;
    case 'percentage_of_gross':
      return percent > 0 ? `${formatSharePercent(percent)} of gross` : null;
    default:
      return percent > 0 ? `${formatSharePercent(percent)} of the pool` : null;
  }
};

const joinerFor = (operator) => (operator === 'OR' ? 'VS' : '+');

export const describePoolMemberDeal = (member, { formatAmount, poolOperator }) => {
  const guarantee = amountOf(member.guarantee);
  const share = shareFor(member);
  const operator = GUARANTEE_ALWAYS_ADDED.includes(member.payout_strategy)
    ? 'AND'
    : member.dollar_or_percentage_operator || poolOperator;

  let deal;
  if (guarantee > 0 && share) deal = `${formatAmount(guarantee)} ${joinerFor(operator)} ${share}`;
  else if (share) deal = share;
  else deal = formatAmount(guarantee);

  const cap = amountOf(member.artist_payout_cap);
  const floor = amountOf(member.artist_payout_floor);
  if (cap > 0) deal += `, capped at ${formatAmount(cap)}`;
  if (floor > 0) deal += `, at least ${formatAmount(floor)}`;
  return deal;
};

export const describePoolDeal = (terms, { formatAmount, doorDealLabel }) => {
  const guarantee = amountOf(terms.dollar_amount);
  const percent = amountOf(terms.upside_percentage);
  if (guarantee > 0 && percent > 0) return `${formatAmount(guarantee)} ${joinerFor(terms.dollar_or_percentage_operator)} ${formatSharePercent(percent)}`;
  if (percent > 0) return doorDealLabel ? `${doorDealLabel} — ${formatSharePercent(percent)}` : formatSharePercent(percent);
  return formatAmount(guarantee);
};
